const getBorderName = (direction, locationA, locationB) => {
    if (direction) {
        return `${locationA} to ${locationB}`;
    }
    return `${locationB} to ${locationA}`;
} 

export default getBorderName;